export var AnimationMode;
(function (AnimationMode) {
  AnimationMode["auto"] = "auto";
  AnimationMode["increase"] = "increase";
  AnimationMode["decrease"] = "decrease";
  AnimationMode["random"] = "random";
})(AnimationMode || (AnimationMode = {}));